import type { PaymentRecord, PaymentTxnStatus } from '../types'
import { dateRanges } from './bookings'

export { dateRanges }

export const paymentTxnStatuses: PaymentTxnStatus[] = [
  'paid',
  'pending',
  'failed',
  'refunded',
]

export const paymentTxnStatusLabels: Record<PaymentTxnStatus, string> = {
  paid: 'Paid',
  pending: 'Pending',
  failed: 'Failed',
  refunded: 'Refunded',
}

/**
 * Stand-in rows mirroring the Payments design. Swap this module for an API call when
 * the backend lands; nothing else in the page reads payment data directly.
 */
export const payments: PaymentRecord[] = [
  {
    id: 'pay-1',
    transactionId: 'TXN-458963215',
    invoice: 'INV-2026-10254',
    customer: {
      name: 'John Smith',
      email: 'john@email.com',
      phone: '+43 664 123 4567',
    },
    bookingId: 'SCB-10254',
    service: 'Transfers' as const,
    route: { from: 'Hallstatt', to: 'vienna' },
    routeLabel: 'Vienna Airport → Salzburg',
    vehicle: 'Premium Saloon',
    driver: 'Michael Weber',
    amountEur: 85,
    taxesEur: 0,
    discountEur: 0,
    method: 'credit-card',
    methodLabel: 'Credit Card',
    gateway: 'Stripe',
    status: 'paid',
    paidAt: '2026-06-17T15:00:00',
  },
  {
    id: 'pay-2',
    transactionId: 'TXN-458963216',
    invoice: 'INV-2026-10255',
    customer: {
      name: 'John Smith',
      email: 'john@email.com',
      phone: '+43 664 123 4567',
    },
    bookingId: 'SCB-10254',
    service: 'Transfers' as const,
    route: { from: 'Hallstatt', to: 'vienna' },
    routeLabel: 'Vienna Airport → Salzburg',
    vehicle: 'Premium Saloon',
    driver: 'Michael Weber',
    amountEur: 85,
    taxesEur: 0,
    discountEur: 0,
    method: 'credit-card',
    methodLabel: 'Credit Card',
    gateway: 'Stripe',
    status: 'paid',
    paidAt: '2026-06-17T15:00:00',
  },
  {
    id: 'pay-3',
    transactionId: 'TXN-458963217',
    invoice: 'INV-2026-10256',
    customer: {
      name: 'Anna Keller',
      email: 'anna.keller@email.com',
      phone: '+43 664 555 0199',
    },
    bookingId: 'SCB-10260',
    service: 'Transfers' as const,
    route: { from: 'Salzburg', to: 'Kitzbühel' },
    routeLabel: 'Salzburg → Kitzbühel',
    vehicle: 'Premium van',
    driver: 'Lukas Berger',
    amountEur: 120,
    taxesEur: 0,
    discountEur: 10,
    method: 'paypal',
    methodLabel: 'Paypal',
    gateway: 'PayPal',
    status: 'pending',
    paidAt: '2026-06-17T15:00:00',
  },
  {
    id: 'pay-4',
    transactionId: 'TXN-458963218',
    invoice: 'INV-2026-10257',
    customer: {
      name: 'Marco Rossi',
      email: 'marco.rossi@email.com',
      phone: '+43 660 441 2288',
    },
    bookingId: 'SCB-10261',
    service: 'Day Trips' as const,
    route: { from: 'Salzburg', to: 'Hallstatt' },
    routeLabel: 'Salzburg → Hallstatt',
    vehicle: 'Business Van',
    driver: 'Sophie Lang',
    amountEur: 95,
    taxesEur: 0,
    discountEur: 0,
    method: 'paypal',
    methodLabel: 'Paypal',
    gateway: 'PayPal',
    status: 'pending',
    paidAt: '2026-07-15T11:30:00',
  },
  {
    id: 'pay-5',
    transactionId: 'TXN-458963219',
    invoice: 'INV-2026-10258',
    customer: {
      name: 'Elena Fuchs',
      email: 'elena.fuchs@email.com',
      phone: '+43 676 882 1144',
    },
    bookingId: 'SCB-10262',
    service: 'Hourly Drivers' as const,
    route: { from: 'Vienna', to: 'Salzburg' },
    routeLabel: 'Vienna → Salzburg',
    vehicle: 'Economy Van',
    driver: 'Thomas Hofer',
    amountEur: 210,
    taxesEur: 20,
    discountEur: 0,
    method: 'credit-card',
    methodLabel: 'Credit Card',
    gateway: 'Stripe',
    status: 'failed',
    paidAt: '2026-07-20T09:15:00',
  },
  {
    id: 'pay-6',
    transactionId: 'TXN-458963220',
    invoice: 'INV-2026-10259',
    customer: {
      name: 'David Chen',
      email: 'david.chen@email.com',
      phone: '+43 699 330 7788',
    },
    bookingId: 'SCB-10263',
    service: 'Transfers' as const,
    route: { from: 'Airport', to: 'City Centre' },
    routeLabel: 'Airport → City Centre',
    vehicle: 'Standard Saloon',
    driver: 'Michael Weber',
    amountEur: 45,
    taxesEur: 0,
    discountEur: 0,
    method: 'credit-card',
    methodLabel: 'Credit Card',
    gateway: 'Stripe',
    status: 'refunded',
    paidAt: '2026-08-02T16:45:00',
  },
  {
    id: 'pay-7',
    transactionId: 'TXN-458963221',
    invoice: 'INV-2026-10264',
    customer: {
      name: 'John Smith',
      email: 'johnsmith@email.com',
      phone: '+43 664 123 4567',
    },
    bookingId: 'SCB-10254',
    service: 'Transfers' as const,
    route: { from: 'Hallstatt', to: 'vienna' },
    routeLabel: 'Vienna Airport → Salzburg',
    vehicle: 'Premium Saloon',
    driver: 'Michael Weber',
    amountEur: 85,
    taxesEur: 0,
    discountEur: 0,
    method: 'paypal',
    methodLabel: 'Paypal',
    gateway: 'PayPal',
    status: 'pending',
    paidAt: '2026-06-17T15:00:00',
  },
  {
    id: 'pay-8',
    transactionId: 'TXN-458963222',
    invoice: 'INV-2026-10265',
    customer: {
      name: 'Laura Braun',
      email: 'laura.braun@email.com',
      phone: '+43 650 991 3344',
    },
    bookingId: 'SCB-10266',
    service: 'Transfers' as const,
    route: { from: 'Munich', to: 'Salzburg' },
    routeLabel: 'Munich Airport → Salzburg',
    vehicle: 'Premium Saloon',
    driver: 'Lukas Berger',
    amountEur: 160,
    taxesEur: 0,
    discountEur: 0,
    method: 'credit-card',
    methodLabel: 'Credit Card',
    gateway: 'Stripe',
    status: 'paid',
    paidAt: '2026-08-05T08:00:00',
  },
]
